var H = require("hogan.js");
window.gettext || require("ehogan-loader/gt.js");
window.jscAdd || require("ehogan-loader/jscmanager.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");t.b("<br>");t.b(t.v(interpolate( gettext("Чтобы привязать профиль %(external)s, введите пароль:"), {'external': t.d("externalName",c,p,1)||""}, true)));t.b("\n");return t.fl(); },partials: {}, subs: {  }}, "<br>{{ ___4___ }}\n", H);return T[arguments[0] instanceof Array ? "ri" : "render"].apply(T, arguments); };


//////////////////
// WEBPACK FOOTER
// ./static-source/messages/for_link_profile.html
// module id = 196
// module chunks = 4